import { Logo } from '../shared/Logo'
import { GhostButton } from '../shared/GhostButton'

export function Footer() {
  return (
    <footer className="mx-auto max-w-7xl px-4 md:px-6 py-10">
      <div className="card rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <Logo/>
        <div className="text-xs text-[#8da0d0]">
          © {new Date().getFullYear()} Laurel. Shareable proof, without the overshare.
        </div>
        <div className="flex gap-2">
          <GhostButton>Privacy</GhostButton>
          <GhostButton>Security</GhostButton>
        </div>
      </div>
    </footer>
  )
}
